import React from 'react';
import {TabView} from '../../../components/tab';
import {GroupFilter, SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '@unthinkable/react-filters';
import {AddButton} from '../../../components/button/AddButton';
import {BudgetRequestAccountTable, BudgetTable} from './BudgetRequestTables';
import {useAppStateContext} from '../../../providers/AppState';
import {
  AutomaticPaymentApproverTable,
  AutomaticPaymentFinanceApproverTable,
  AutomaticPaymentRequesterTable,
} from './AutomaticPaymentTables';

export const AutomaticPaymentRequesterTab = props => {
  let {route: {params} = {}} = props;
  let {filterValues, searchValue, onChangeFilter, applyFilter} = useFilter({});
  const {
    user: {employee},
  } = useAppStateContext();
  const tabs = {
    Requested: {
      label: 'Requested',
      view: (
        <AutomaticPaymentRequesterTable
          tab={'Requested'}
          filterValues={filterValues}
          addOnFilter={{
            // status: 'Requested',
            requested_by: employee._id,
            $or: [
              {status: 'Requested'},
              {status: 'Approved', approver_status: 'Finance'},
            ],
          }}
          searchValue={searchValue}
          {...props}
        />
      ),
      eventSourceId: 'budget',
      api: '/automaticpayment/details',
      search: searchValue,
      searchFields: 'invoice_number',
      addOnFilter: {
        requested_by: employee._id,
        // status: 'Requested',
        $or: [
          {status: 'Requested'},
          {status: 'Approved', approver_status: 'Finance'},
        ],
        ...filterValues.filter,
      },
      limit: 500,
    },
    Active: {
      label: 'Active Transactions',
      view: (
        <AutomaticPaymentRequesterTable
          tab={'Active'}
          filterValues={filterValues}
          addOnFilter={{
            status: 'Active',
            requested_by: employee._id,
            stop_txn_request: {$exists: false},
          }}
          {...props}
        />
      ),
      search: searchValue,
      searchFields: 'invoice_number',
      eventSourceId: 'budget',
      api: '/automaticpayment/details',
      addOnFilter: {
        requested_by: employee._id,
        status: 'Active',
        stop_txn_request: {$exists: false},
        ...filterValues.filter,
      },
    },
    stop_txn: {
      label: 'Stop Transaction Requests',
      view: (
        <AutomaticPaymentRequesterTable
          tab={'StopTxn'}
          filterValues={filterValues}
          addOnFilter={{
            status: 'Active',
            requested_by: employee._id,
            stop_txn_request: true,
          }}
          {...props}
        />
      ),
      search: searchValue,
      searchFields: 'invoice_number',
      eventSourceId: 'budget',
      api: '/automaticpayment/details',
      addOnFilter: {
        requested_by: employee._id,
        status: 'Active',
        stop_txn_request: true,
        ...filterValues.filter,
      },
    },
    Inactive: {
      label: 'Inactive Transactions',
      view: (
        <AutomaticPaymentRequesterTable
          tab={'Inactive'}
          filterValues={filterValues}
          addOnFilter={{status: 'Inactive', requested_by: employee._id}}
          {...props}
        />
      ),
      search: searchValue,
      searchFields: 'invoice_number',
      eventSourceId: 'budget',
      api: '/automaticpayment/details',
      addOnFilter: {
        requested_by: employee._id,
        status: 'Inactive',
        ...filterValues.filter,
      },
    },
    Rejected: {
      label: 'Rejected',
      view: (
        <AutomaticPaymentRequesterTable
          tab={'Rejected'}
          filterValues={filterValues}
          addOnFilter={{status: 'Rejected', requested_by: employee._id}}
          {...props}
        />
      ),
      search: searchValue,
      searchFields: 'invoice_number',
      api: '/automaticpayment/details',
      eventSourceId: 'budget',
      addOnFilter: {
        requested_by: employee._id,
        status: 'Rejected',
        ...filterValues.filter,
      },
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Team',
              api: '/employeeteams',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'team',
            },
            {
              type: 'autoComplete',
              label: 'Vendor',
              api: '/vendors',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'vendor',
            },
            {
              type: 'date',
              label: 'Requested On',
              field: 'request_date',
            },
          ]}
        />,
        <AddButton title="Card" view={'add-automatic-payment-request'} />,
      ]}
    />
  );
};

export const AutoaticPaymentApproverTab = props => {
  let {route: {params} = {}, orgView} = props;
  let {filterValues, searchValue, onChangeFilter, applyFilter} = useFilter({});
  const {
    user: {employee},
  } = useAppStateContext();
  let addOnFilter = {};
  if (!orgView) {
    addOnFilter = {approver: employee._id};
  }
  const tabs = {
    Active: {
      label: 'Requested',
      view: (
        <AutomaticPaymentApproverTable
          tab={'ApproverActive'}
          addOnFilter={{status: 'Requested'}}
          orgView={orgView}
          {...props}
        />
      ),
      eventSourceId: 'budget',
      api: `/automaticpayment/details`,
      addOnFilter: {
        ...filterValues.filter,
        status: 'Requested',
        ...addOnFilter,
      },
    },
    close: {
      label: 'Closed',
      view: (
        <AutomaticPaymentApproverTable
          tab={'ApproverClosed'}
          addOnFilter={{
            status: {$in: ['Approved', 'Rejected', 'Active', 'Inactive']},
            // approver_status: 'Team Head',
            ...filterValues.filter,
          }}
          orgView={orgView}
          {...props}
        />
      ),
      eventSourceId: 'budget',
      api: `/automaticpayment/details`,
      addOnFilter: {
        status: {$in: ['Approved', 'Rejected', 'Active', 'Inactive']},
        // approver_status: 'Team Head',
        ...filterValues.filter,
        ...addOnFilter,
      },
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Team',
              api: '/employeeteams',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'team',
            },
            {
              type: 'autoComplete',
              label: 'Vendor',
              api: '/vendors',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'vendor',
            },
            // {
            //   type: 'autoComplete',
            //   label: 'Status',
            //   options: ['Approved', 'Rejected'],
            //   field: 'status',
            // },
          ]}
        />,
      ]}
    />
  );
};

export const FinanceAutomaticPaymentTab = props => {
  let {routes: {params} = {}} = props;
  let {filterValues, searchValue, onChangeFilter, applyFilter} = useFilter({});
  let currentdate = new Date();
  let monthFirstDate = new Date(
    currentdate.getFullYear(),
    currentdate.getMonth(),
    1,
  );

  const tabs = {
    requested: {
      label: 'Requested',
      view: (
        <AutomaticPaymentFinanceApproverTable
          tab={'FinanceRequested'}
          addOnFilter={{
            status: 'Approved',
            approver_status: 'Finance',
            approved_by_finance_date: {$exists: false},
            ...filterValues.filter,
          }}
          {...props}
        />
      ),
      api: '/automaticpayment/details',
      addOnFilter: {
        status: 'Approved',
        approver_status: 'Finance',
        approved_by_finance_date: {$exists: false},
        ...filterValues.filter,
      },
      limit: 500,
    },
    active_transaction: {
      label: 'Active Transactions',
      view: (
        <AutomaticPaymentFinanceApproverTable
          tab={'ApproverClosed'}
          addOnFilter={{
            // $or: [
            //   {
            //     status: 'Approved',
            //     approver_status: 'Finance',
            //     approved_by_finance_date: {$exists: true},
            //   },
            //   {
            //     status: {$in: ['Rejected', 'Active', 'Inactive']},
            //     approver_status: 'Finance',
            //   },
            // ],
            status: 'Active',
            approver_status: 'Finance',
            approved_by_finance_date: {$exists: true},
            ...filterValues.filter,
          }}
          {...props}
        />
      ),
      eventSourceId: 'budget',
      api: `/automaticpayment/details`,
      addOnFilter: {
        // $or: [
        //   {
        //     status: 'Approved',
        //     approver_status: 'Finance',
        //     approved_by_finance_date: {$exists: true},
        //   },
        //   {
        //     status: {$in: ['Rejected', 'Active', 'Inactive']},
        //     approver_status: 'Finance',
        //   },
        // ],
        status: 'Active',
        approver_status: 'Finance',
        approved_by_finance_date: {$exists: true},
        ...filterValues.filter,
      },
    },
    stop_txn: {
      label: 'Stop Transaction Requests',
      view: (
        <AutomaticPaymentFinanceApproverTable
          tab={'StopTxn'}
          addOnFilter={{
            // $or: [
            //   {
            //     status: 'Approved',
            //     approver_status: 'Finance',
            //     approved_by_finance_date: {$exists: true},
            //   },
            //   {
            //     status: {$in: ['Rejected', 'Active', 'Inactive']},
            //     approver_status: 'Finance',
            //   },
            // ],
            status: 'Active',
            approver_status: 'Finance',
            approved_by_finance_date: {$exists: true},
            stop_txn_request: true,
            ...filterValues.filter,
          }}
          {...props}
        />
      ),
      eventSourceId: 'budget',
      api: `/automaticpayment/details`,
      addOnFilter: {
        // $or: [
        //   {
        //     status: 'Approved',
        //     approver_status: 'Finance',
        //     approved_by_finance_date: {$exists: true},
        //   },
        //   {
        //     status: {$in: ['Rejected', 'Active', 'Inactive']},
        //     approver_status: 'Finance',
        //   },
        // ],
        status: 'Active',
        approver_status: 'Finance',
        approved_by_finance_date: {$exists: true},
        stop_txn_request: true,
        ...filterValues.filter,
      },
    },
    inactive_transaction: {
      label: 'Inactive Transactions',
      view: (
        <AutomaticPaymentFinanceApproverTable
          tab={'InactiveTransactions'}
          addOnFilter={{
            status: 'Inactive',
            ...filterValues.filter,
          }}
          {...props}
        />
      ),
      eventSourceId: 'budget',
      api: `/automaticpayment/details`,
      addOnFilter: {
        status: 'Inactive',
        ...filterValues.filter,
      },
    },
    rejected: {
      label: 'Rejected',
      view: (
        <AutomaticPaymentFinanceApproverTable
          addOnFilter={{
            status: 'Rejected',
            rejected_by: 'Finance',
            // rejected_by_finance_date: {$exists: true},
            ...filterValues.filter,
          }}
          {...props}
        />
      ),
      api: '/automaticpayment/details',
      addOnFilter: {
        status: 'Rejected',
        rejected_by: 'Finance',
        ...filterValues.filter,
      },
      limit: 500,
    },
  };
  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Team',
              api: '/employeeteams',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'team',
            },
            {
              type: 'autoComplete',
              label: 'Vendor',
              api: '/vendors',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'vendor',
            },
            {
              type: 'date',
              label: 'Requested On',
              field: 'request_date',
            },
          ]}
        />,
      ]}
    />
  );
};
